/** When your routing table is too long, you can split it into small modules **/
const activeMenu = '/acceptOrderInfo'
const iconName = 'el-icon-s-order'
export default [
  //受注、出荷
  {
    path: activeMenu,
    name: 'acceptOrderInfo',
    alwaysShow: true,
    component: () => import('@/layout/Layout'),
    redirect: '/acceptOrderInfo/acceptOrderInfoOverview',
    meta: {
      order: 300,
      icon: iconName,
      title: 'resource.MENU.ACCEPT_ORDER_TITLE'
    },
    //受注
    children: [
      {
        path: 'acceptOrderInfoOverview',
        component: () => import('@/views/acceptOrderInfo/acceptOrderInfo'),
        name: 'acceptOrderInfoOverview',
        hidden: false,
        meta: {
          order: 301,
          activeMenu: activeMenu,
          icon: iconName,
          //角色：管理者、事務
          permission: ['acceptOrderInfo'],
          title: 'resource.MENU.ACCEPT_ORDER_VIEW',
        }
      },
      //出荷
      {
        path: 'sendInfoOverview',
        component: () => import('@/views/sendInfo/sendInfo'),
        name: 'sendInfoOverview',
        hidden: false,
        meta: {
          order: 302,
          icon: iconName,
          //角色：管理者、事務
          permission: ['sendInfo'],
          title: 'resource.MENU.OUT_BOUND_VIEW',
        }
      },
       //請求
      {
        path: 'requestInfoOverview',
        component: () => import('@/views/requestInfo/requestInfo'),
        name: 'requestInfoOverview',
        hidden: false,
        meta: {
          order: 303,
          icon: iconName,
         //角色：管理者、事務
         permission: ['requestInfo'],
          title: 'resource.MENU.REQUEST_VIEW',
        }
      },
    ]
  }
]

